/**
 * Determine whether an object is an 'invalidate' atom
 * @param {*} value The object to test
 * @return {boolean} Whether the object is an 'invalidate' atom
 */
function isInvalidate(value) {
  return Boolean(value) && (value.$type === 'invalidate');
}

module.exports = isInvalidate;
